import {
  InteractionStatus,
  EventType,
  EventMessageUtils,
  type AccountInfo,
  type EventMessage,
  type AuthenticationResult,
} from '@azure/msal-browser'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { msalInstance } from '../authConfig'
import { CustomNavigationClient } from '../router/CustomNavigationClient'
import { useRouter } from 'vue-router'

export const useMsalStore = defineStore('msal', () => {
  const router = useRouter()
  const inProgress = ref<InteractionStatus>(InteractionStatus.Startup)

  // Permet à MSAL de profiter des fonctions de navigation du
  // routeur lorsque MSAL redirige entre les pages de l'application
  const navigationClient = new CustomNavigationClient(router)
  msalInstance.setNavigationClient(navigationClient)

  // Fixe l'utilisateur courant
  const allAccounts = msalInstance.getAllAccounts()
  if (allAccounts.length > 0) {
    msalInstance.setActiveAccount(allAccounts[0])
  }

  msalInstance.addEventCallback((event) => {
    const loginSucces = [EventType.LOGIN_SUCCESS, EventType.ACQUIRE_TOKEN_SUCCESS].includes(event.eventType as any)
    if (loginSucces && event.payload) {
      const payload = event.payload as AuthenticationResult | AccountInfo
      const account =  'account' in payload ? payload.account : payload
      if (account !== msalInstance.getActiveAccount()) {
        msalInstance.setActiveAccount(account)
      }
    }
  })


  msalInstance.addEventCallback((message: EventMessage) => {
    const status = EventMessageUtils.getInteractionStatusFromEvent(message, inProgress.value)
    if (status !== null) {
      inProgress.value = status
    }
  })

  return {
    inProgress,
    msalInstance,
  }
})
